import type { SubmitHandler } from 'react-hook-form';
import { useState } from 'react';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiCreateAdResponseBody } from '~/lib/api/modules/Ads';
import type { IUseCreateAdMutationValues } from '~/lib/api/modules/Ads/hooks/useCreateAdMutation';
import type { IAdFormValues } from './AdForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useCreateAdMutation } from '~/lib/api/modules/Ads/hooks/useCreateAdMutation';
import { AdForm } from './AdForm';

export type ICreateAdFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiCreateAdResponseBody,
    inputValues: IUseCreateAdMutationValues,
  ) => void;
  cancelUrl?: string;
  appId: string;
};

export const CreateAdForm: React.FC<ICreateAdFormProps> = (props) => {
  const { sx, onSuccess, cancelUrl, appId } = props;
  const createAdMutation = useCreateAdMutation();
  const [disabled, setDisabled] = useState(false);

  const handleSubmit: SubmitHandler<IAdFormValues> = (values) => {
    if (createAdMutation.isLoading) {
      return;
    }

    return createAdMutation.mutateAsync(
      {
        appId,
        body: {
          active: !values.disabled,
          campaignId: values.name,
          format: values.feedFormat!,
          location: values.location!,
          locationOpts:
            values.location === 'feed'
              ? [
                  values.feedPosition || '0',
                  values.feedRecurrentStep || '0',
                  values.feedIndex || '0',
                  values.feedReccurentMaxIndex || '0',
                ].join(':')
              : values.location === 'article'
                ? [values.articlePosition].join('::')
                : undefined,
          media: values.medias![0].id,
          mediaType: values.medias![0].type!,
          url: values.url!,
          limits: {
            maxDisplays: values.maxDisplays ? Number(values.maxDisplays) : 0,
            maxClicks: values.maxClicks ? Number(values.maxClicks) : 0,
            notBefore: values.startAt,
            notAfter: values.endAt,
          },
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock draft={disabled} sx={sx} draftOutlineSize="lg">
      <AdForm
        appId={appId}
        mode="creation"
        cancelUrl={cancelUrl}
        onSubmit={handleSubmit}
        onDisabledStatusChange={setDisabled}
        first
      />
    </ContentBlock>
  );
};
